// test769
(769 && 0);
